import { makeStyles, createStyles } from '@maas-components/styles'

const styles = () => {
  return createStyles({
    header: {
      background: '#424A52',
    },
    icon: {
      color: '#ffffff',
      '&:hover': {
        opacity: 0.8,
      },
      padding: '10px',
      borderRadius: '5px',
    },
    logo: {
      width: 250,
      color: '#ffffff',
      marginTop: '10px',
    },
  })
}

export default makeStyles(styles, { name: 'AppHeader' })
